import moment from "moment";
import { IconEdit, IconEye, IconBrandYoutube, IconPalette, IconTrash, IconBrandFacebook, IconWorld, IconBrandInstagram, IconBrandWhatsapp, IconBrandX, IconImageInPicture, IconPhoto, IconVideo } from '@tabler/icons-react';
import { useNavigate } from "react-router-dom";
import getRandomColor from "../../getRandomColor";
import ToolTip from "../../Layout/tooltip";
import config from "../../../config";
import { useAuth } from "../../Context/store/context";
import { _delete } from "../../../apiClient";
import { _showToast } from "../../../toastHelper";

export default function InvitationCard(props) {
    const { showLoader, hideLoader } = useAuth();

    const navigate = useNavigate();
    const editHandler = (e, url) => {
        return navigate(url);
    }

    const changeLiveUrlHandler = (id) => {
        props.changeLive(id);
    }

    const viewInvitationHandler = (event, url) => {
        event.preventDefault();
        window.open(url, "_blank");
    }

    const deleteEvent = async (event, id) => {
        event.preventDefault();
        const confirmation = window.confirm(
            "Are you sure you want to delete this? This action cannot be undone."
        );

        if (confirmation) {
            showLoader();
            await _delete(`/events/${id}`)
                .then(async () => {
                    hideLoader();
                    _showToast("Selected invitation deleted successfully", "success");
                    await props.refreshData();
                })
                .catch((error) => {
                    hideLoader();
                    _showToast(error, "error");
                });
        }
    }

    const changeThemeHandler = (e, eventId, categoryId) => {
        e.preventDefault();
        let url = `/change-theme/${eventId}/${categoryId}`
        return navigate(url);
    }

    return (<>
        <div className="col-md-4">
            <div className="main-card card-clickable card">
                <div className="g-0 align-items-center row">
                    <div className="col-md-12" style={{ minHeight: "160px", width: "100%" }}>
                        <div className="placeholder-glow position-relative"
                            style={{ borderRadius: "5px", boxSizing: "border-box", display: "inline-block", position: "relative", height: "200px", width: "100%" }}>
                            {!props.data.eventThumbnail && (
                                <div className="placeholder w-100 h-100" style={{ backgroundColor: getRandomColor(), opacity: "1" }}></div>)}
                            {props.data.eventThumbnail && props.data.eventThumbnail.trim() !== "" && (
                                <img style={{ borderRadius: "5px", objectFit: "cover", height: "200px", width: "100%", objectPosition: "100% 20%" }}
                                    src={props.data.eventThumbnail} />)}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="px-1 py-3 pb-0 card-body">
                            <h2 className="card-title-big mb-0 text-truncate">{props.data.eventTitle}</h2>
                            <small className="text-muted">{moment(props.data.eventDate).format("dddd, MMMM DD, YYYY")}</small>
                            <br />
                            <div className="card-text d-flex flex-wrap gap-2 mt-1">
                                <span className="badge bg-primary statistics-invitation-card" >
                                    <IconPhoto size={16} />{props.data.imageCount}
                                </span>
                                <span className="badge bg-primary statistics-invitation-card" >
                                    <IconVideo size={16} />{props.data.videoCount}
                                </span>
                            </div>
                            <div className="card-text d-flex flex-wrap gap-2 mt-1">
                                <ToolTip title="Invitation">
                                    <span className="badge bg-secondary statistics-invitation-card" >
                                        <IconEye size={16} />{props.data.invitationVisits}
                                    </span>
                                </ToolTip>
                                <ToolTip title="Facebook">
                                    <span className="badge bg-secondary statistics-invitation-card">
                                        <IconBrandFacebook size={16} />{props.data.facebookVisits}
                                    </span>
                                </ToolTip>
                                <ToolTip title="Instagram">
                                    <span className="badge bg-secondary statistics-invitation-card">
                                        <IconBrandInstagram size={16} />{props.data.instagramVisits}
                                    </span>
                                </ToolTip>
                                <ToolTip title="Youtube">
                                    <span className="badge bg-secondary statistics-invitation-card">
                                        <IconBrandYoutube size={16} />{props.data.youtubeVisits}
                                    </span>
                                </ToolTip>
                                <ToolTip title="Twitter">
                                    <span className="badge bg-secondary statistics-invitation-card">
                                        <IconBrandX size={16} />{props.data.twitterVisits}
                                    </span>
                                </ToolTip>
                                <ToolTip title="Whatsapp">
                                    <span className="badge bg-secondary statistics-invitation-card">
                                        <IconBrandWhatsapp size={16} />{props.data.whatsappVisits}
                                    </span>
                                </ToolTip>
                                <ToolTip title="Website">
                                    <span className="badge bg-secondary statistics-invitation-card">
                                        <IconWorld size={16} />{props.data.siteVisits}
                                    </span>
                                </ToolTip>
                            </div>
                            <div>
                                <div className="d-flex gap-1 mt-3 flex-wrap">
                                    <ToolTip title="Edit Invitation" id={0}>
                                        <button className="btn btn-soft-primary waves-effect waves-light"
                                            title="Edit Invitation"
                                            onClick={(e) => editHandler(e, `/invitations/${props.data.categoryCode}/${props.data.id}`)}>
                                            <IconEdit size={20} />
                                        </button>
                                    </ToolTip>
                                    <ToolTip title="View Invitation" id={1}>
                                        <button className="btn btn-soft-primary waves-effect waves-light"
                                            title="View Invitation"
                                            onClick={(e) => viewInvitationHandler(e, props.data.eventUrl)}>
                                            <IconEye size={20} />
                                        </button>
                                    </ToolTip>
                                    <ToolTip title="Change Live Url" id={2}>
                                        <button className="btn btn-soft-primary waves-effect waves-light"
                                            title="Change Live Url"
                                            onClick={(e) => changeLiveUrlHandler(props.data.id)}>
                                            <IconBrandYoutube size={20} />
                                        </button>
                                    </ToolTip>
                                    <ToolTip title="Change Theme" id={3}>
                                        <button className="btn btn-soft-primary waves-effect waves-light"
                                            title="Change Theme" onClick={(e) => changeThemeHandler(e, props.data.id, props.data.categoryId)} >
                                            <IconPalette size={20} />
                                        </button>
                                    </ToolTip>
                                    <ToolTip title="Delete Invitation" id={4}>
                                        <button className="btn btn-soft-danger waves-effect waves-light"
                                            title="Delete Invitation" onClick={(e) => deleteEvent(e, props.data.id)}>
                                            <IconTrash size={20} />
                                        </button>
                                    </ToolTip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    </>)
}